import React from 'react';
import "../../css/components/infoPanel/infoPanelFooterSection.css";

function InfoPanelFooterSection() {

    return (

        <div className="info-panel-footer">
        </div>
    );
}

export default InfoPanelFooterSection;